import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TRADING_NAV_ITEMS, isNavItemActive } from './trading-nav-items';
import ThemeToggle from './ThemeToggle';
import { useScreenMaster } from './ScreenMasterContext';
import './MobileBottomNav.css';

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { isNavKeyEnabled } = useScreenMaster();
  const [moreOpen, setMoreOpen] = useState(false);

  const visibleItems = TRADING_NAV_ITEMS.filter(
    (item) => item.key === 'screen-master' || isNavKeyEnabled(item.key)
  );

  const MORE_ITEMS = visibleItems.filter(
    (item) => !['normal', 'cnc', 'sold', 'future', 'screen-master'].includes(item.key)
  );

  const PRIMARY_ITEMS = [
    visibleItems.find((i) => i.key === 'screen-master'),
    visibleItems.find((i) => i.key === 'normal'),
    visibleItems.find((i) => i.key === 'future'),
    visibleItems.find((i) => i.key === 'sold'),
    { path: '#more', label: 'More', icon: '☰', key: 'more' }
  ].filter(Boolean);

  useEffect(() => {
    setMoreOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!moreOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setMoreOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [moreOpen]);

  const moreActive = MORE_ITEMS.some((item) => isNavItemActive(pathname, item));

  return (
    <>
      {moreOpen && (
        <button
          type="button"
          className="mobile-more-backdrop"
          aria-label="Close menu"
          onClick={() => setMoreOpen(false)}
        />
      )}

      {moreOpen && (
        <div className="mobile-more-sheet" role="dialog" aria-label="More screens">
          <div className="mobile-more-handle" />
          <p className="mobile-more-title">More screens</p>
          <div className="mobile-more-theme">
            <ThemeToggle />
          </div>
          <div className="mobile-more-grid">
            {MORE_ITEMS.map((item) => (
              <Link
                key={item.key}
                to={item.path}
                className={`mobile-more-item${isNavItemActive(pathname, item) ? ' active' : ''}`}
                onClick={() => setMoreOpen(false)}
              >
                <span aria-hidden>{item.icon}</span>
                <strong>{item.label}</strong>
              </Link>
            ))}
          </div>
        </div>
      )}

      <nav className="mobile-bottom-nav" aria-label="Primary trading tabs">
        {PRIMARY_ITEMS.map((item) => {
          if (item.key === 'more') {
            return (
              <button
                key="more"
                type="button"
                className={`mobile-bottom-tab${moreOpen || moreActive ? ' active' : ''}`}
                onClick={() => setMoreOpen((v) => !v)}
              >
                <span aria-hidden>{item.icon}</span>
                <em>{item.label}</em>
              </button>
            );
          }
          return (
            <Link
              key={item.key}
              to={item.path}
              className={`mobile-bottom-tab${isNavItemActive(pathname, item) ? ' active' : ''}`}
            >
              <span aria-hidden>{item.icon}</span>
              <em>{item.label}</em>
            </Link>
          );
        })}
      </nav>
    </>
  );
}
